import {Icon, IconButton} from "@fluentui/react";
import React, {useMemo} from "react";
import {SupportStatusEnum} from "../API";
import {theme} from "../index";

interface ISupportStatusIconProps {
    status: SupportStatusEnum | string;
    useButton?: boolean;
}

export const iconDataFromStatus = (status: string | SupportStatusEnum) => {
    let icon:
        | ""
        | "CircleRing"
        | "CircleFill"
        | "CirclePause"
        | "SkypeCircleCheck"
        | "UserPause"
        | "SyncStatus"
        | "ProgressRingDots"
        | "Repair"
        | "UpgradeAnalysis"
        | "Blocked2" = "";

    if (isNaN(status as any)) {
        status = SupportStatusEnum[status as any];
    }

    switch (status) {
        case SupportStatusEnum.Open:
            icon = "CircleRing";
            break;
        case SupportStatusEnum.Closed:
            icon = "CircleFill";
            break;
        case SupportStatusEnum.Pending:
            icon = "CirclePause";
            break;
        case SupportStatusEnum.Resolved:
            icon = "SkypeCircleCheck";
            break;
        case SupportStatusEnum.ForReview:
            icon = "SyncStatus";
            break;
        case SupportStatusEnum.InProgress:
            icon = "ProgressRingDots";
            break;
        case SupportStatusEnum.Maintenance:
            icon = "Repair";
            break;
        case SupportStatusEnum.Spam:
            icon = "Blocked2";
            break;
        case SupportStatusEnum.WaitingForOffer:
            icon = "UserPause";
            break;
        case SupportStatusEnum.PantheonUpgrade:
            icon = "UpgradeAnalysis";
            break;
    }

    return {icon};
};

export const SupportStatusIcon = ({
                                      status,
                                      useButton,
                                  }: ISupportStatusIconProps) => {
    const iconData = useMemo(() => iconDataFromStatus(status), [status]);

    if (useButton) {
        return <IconButton iconProps={{iconName: iconData.icon}}/>;
    }

    return (
        <Icon
            iconName={iconData.icon}
            styles={{
                root: {
                    fontWeight: "bold",
                    fontSize: 16,
                    color: theme.palette?.themePrimary,
                },
            }}
        />
    );
};
